import { render } from "./Right12.vue?vue&type=template&id=607913e3&scoped=true"
import script from "./Right12.vue?vue&type=script&lang=js"
export * from "./Right12.vue?vue&type=script&lang=js"

import "./Right12.vue?vue&type=style&index=0&id=607913e3&scoped=true&lang=css"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607913e3"]])

export default __exports__